import React from "react";
import PolicyLayout from "./PolicyLayout";

export default function Privacy() {
  return (
    <PolicyLayout title="Privacy Policy" eyebrow="Legal · Privacy" effectiveDate="Last updated: October 11, 2025">
      <p>Your privacy is important to us. This policy explains what information we collect and how we use it.</p>

      <h2>1. Information We Collect</h2>
      <p>
        We collect information you provide directly to us, such as when you create an account, request services, or communicate with us.
        This may include your <strong>name, email address, phone number, address, and payment information</strong>. We also collect
        information automatically when you use our services, such as your <strong>IP address and device information</strong>.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use the information we collect to provide, maintain, and improve our services. This includes processing transactions,
        sending you confirmations and updates, responding to your comments and questions, and providing customer support.
        We may also use your information to communicate with you about products, services, offers, and events.
      </p>

      <h2>3. Information Sharing</h2>
      <p>
        We do not share your personal information with third parties except as described in this policy. We may share information with
        vendors, consultants, and other service providers who need access to such information to carry out work on our behalf.
        We may also share information in response to a request for information if we believe disclosure is in accordance with any
        applicable law, regulation, or legal process.
      </p>

      <h2>4. Data Security</h2>
      <p>
        We take reasonable measures to help protect information about you from loss, theft, misuse, and unauthorized access, disclosure,
        alteration, and destruction.
      </p>

      <h2>5. Your Choices</h2>
      <p>
        You may update, correct, or delete information about you at any time by logging into your online account or emailing us.
        If you wish to delete or deactivate your account, please email us, but note that we may retain certain information as required by
        law or for legitimate business purposes.
      </p>

      <h2>6. Changes to This Policy</h2>
      <p>
        We may change this Privacy Policy from time to time. If we make changes, we will notify you by revising the date at the top of
        the policy and, in some cases, we may provide you with additional notice (such as adding a statement to our homepage or sending
        you a notification).
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:<br />
        📧 <a href="mailto:care@rescigo.com">care@rescigo.com</a>
      </p>
    </PolicyLayout>
  );
}
